module.exports = __webpack_public_path__ + "static/media/seal work.ee145701.png";